export var OverflowScrollingProperty;
(function (OverflowScrollingProperty) {
    OverflowScrollingProperty["auto"] = "auto";
    OverflowScrollingProperty["momentum"] = "touch";
})(OverflowScrollingProperty || (OverflowScrollingProperty = {}));
